<div class="p-mdc-dialog-content">
  <p>An update has been applied. Please re-login to receive the latest updates.</p>
</div>
<div class="action-panel text-right btn-wrapper">
  <div class="action-panel text-right">
    <app-button label="Confirm" buttonClass="btn btn-primary m-left" color="warn" (buttonClick)="onConfirm()" />
    <app-button label="Wait" buttonClass="btn m-left btn-secondary ms-2" color="warn" (buttonClick)="onWait()" />
  </div>
</div>